import { formatYmdInBrussels, brusselsInstantFromYmdAndDbEndTime } from '@/lib/brusselsSchedule';

function toCalendarUtcCompact(isoOrDate) {
    return new Date(isoOrDate).toISOString().replace(/-|:|\.\d\d\d/g, '');
}

export function useCalendar() {
    const googleCalendarUrl = (event) => {
        const startTime = toCalendarUtcCompact(event.date);
        const ymd = formatYmdInBrussels(event.date);
        const endTime = toCalendarUtcCompact(brusselsInstantFromYmdAndDbEndTime(ymd, event.end_time));

        const title = encodeURIComponent(event.title);
        const details = encodeURIComponent(event.description || '');
        const location = encodeURIComponent(event.location || '');

        return `https://www.google.com/calendar/render?action=TEMPLATE&text=${title}&dates=${startTime}/${endTime}&details=${details}&location=${location}&sf=true&output=xml`;
    };

    const downloadIcs = (event) => {
        const startTime = toCalendarUtcCompact(event.date);
        const ymd = formatYmdInBrussels(event.date);
        const endTime = toCalendarUtcCompact(brusselsInstantFromYmdAndDbEndTime(ymd, event.end_time));

        const icsContent = `BEGIN:VCALENDAR
VERSION:2.0
BEGIN:VEVENT
URL:${window.location.origin}/agenda/${event.slug}
DTSTART:${startTime}
DTEND:${endTime}
SUMMARY:${event.title}
DESCRIPTION:${event.description || ''}
LOCATION:${event.location || ''}
END:VEVENT
END:VCALENDAR`;

        const blob = new Blob([icsContent], { type: 'text/calendar;charset=utf-8' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${event.slug}.ics`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return { googleCalendarUrl, downloadIcs };
}
